export default {
  // curSymbol: 'uniswap-eth-omg', // 交易对
  curSymbol: '',
  symbolsInfo: [], // 所有交易对配置信息
  pools: [], // 所有交易对资金池
  klines: [] // klines
};
